import { Card, CardContent, CardHeader } from "../Card";
import { Skeleton } from "../Skeleton";

export function TopRepsSkeleton() {
	return (
		<Card className="flex-1 lg:flex-initial">
			<CardHeader className="flex flex-row items-center justify-between pb-2 gap-2">
				<Skeleton className="h-5 w-[220px]" />
				<Skeleton className="h-5 w-[120px]" />
			</CardHeader>
			<CardContent>
				<Skeleton className="h-8 w-full mb-4" />
				<Skeleton className="h-4 w-[220px] mb-4" />
				<Skeleton className="h-6 w-full mb-2" />
				{Array.from({ length: 6 }).map((_, index) => (
					<Skeleton key={index} className="h-10 w-full mb-2" />
				))}
			</CardContent>
		</Card>
	);
}
